//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: "Pagination",
  meta: {
    description: "Indica contenido relacionado en varias páginas.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  props: {
    showText: {
      type: Boolean,
      required: false,
      default: true
    },
    showInputToGo: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,

      default() {
        return {
          currentPage: 0,
          totalItemCount: 0,
          pageCount: 0,
          count: 0,
          pageToGo: 1,
          pageSize: 0,
          perPage: 0,
          showPageSizeOptions: false,
          pageSizeOptions: [],
          pageSizeText: ""
        };
      },

      meta: {
        description: "Establece la data relacionada al componente",
        example: ""
      }
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },

  data() {
    return {
      pageSizeValue: 0,
      pageButtonCount: 5,
      pageButtonOffset: 2
    };
  },

  computed: {
    pages() {
      const pages = [];
      const offset = this.pageButtonOffset;
      let endAt = this.pageButtonCount;
      let startAt = 1;

      if (this.currentPage > 3 && this.data.pageCount > this.currentPage + offset) {
        endAt = this.currentPage + offset;
        startAt = this.currentPage - offset;
      } else if (this.currentPage > 3 && this.currentPage <= this.data.pageCount) {
        endAt = this.data.pageCount;
        startAt = this.data.pageCount - 4;
      }

      if (startAt <= 0) startAt = 1;
      let qtyButtons = 0;

      if (this.data.pageCount <= endAt) {
        qtyButtons = this.data.pageCount;
      } else {
        qtyButtons = endAt;
      }

      for (let i = startAt; i <= qtyButtons; i++) {
        pages.push(i);
      }

      return pages;
    },

    pagesMobile() {
      const pages = [];
      const offset = 1;
      let endAt = 1;
      let startAt = 1;

      if (this.currentPage > 2 && this.data.pageCount > this.currentPage + offset) {
        endAt = this.currentPage + offset;
        startAt = this.currentPage - offset;
      }

      if (startAt < 0) startAt = 1;
      let qtyButtons = 0;

      if (this.data.pageCount <= endAt) {
        qtyButtons = this.data.pageCount;
      } else {
        qtyButtons = endAt;
      }

      for (let i = startAt; i <= qtyButtons; i++) {
        pages.push(i);
      }

      if (this.currentPage != this.lastPage) return [this.currentPage];
      return pages;
    },

    total() {
      return this.data.totalItemCount;
    },

    pagesSize() {
      return this.data.pageSize || this.data.count || this.data.perPage || this.pageSize;
    },

    startIndex() {
      let startIndex = this.pagesSize * this.currentPage - this.pagesSize;

      if (startIndex === 0) {
        startIndex = 1;
      }

      if (this.data.totalItemCount > 0 && this.currentPage > 1 && this.data.count < 5) {
        startIndex = this.data.totalItemCount - this.data.count;
      }

      if (this.currentPage > 1) {
        startIndex = startIndex + 1;
      }

      return startIndex;
    },

    endIndex() {
      let endIndex = this.startIndex;
      if (this.pagesSize > this.data.count) endIndex += this.data.count;else endIndex += this.pagesSize;
      return endIndex - 1;
    },

    currentPage() {
      return this.data.currentPage;
    },

    lastPage() {
      return this.data.pageCount;
    },

    pageSizeOptions() {
      return this.data.pageSizeOptions;
    },

    pageSizeText() {
      return this.data.pageSizeText;
    },

    showPageSizeOptions() {
      return this.data.showPageSizeOptions;
    },

    pageSizeModel: {
      get() {
        return this.pageSizeValue || this.pagesSize;
      },

      set(val) {
        this.pageSizeValue = val;
        this.$emit("page-size-change", val);
      }

    }
  },
  methods: {
    goToPage(pageNumber) {
      if (pageNumber < 1 || pageNumber > this.data.pageCount) return;

      if (pageNumber !== this.currentPage) {
        this.$emit("pagination-go-page", pageNumber);
      }

      this.pageToGo = pageNumber;
    },

    goToLastPage() {
      if (this.currentPage == this.data.pageCount) return;
      this.$emit("pagination-go-page", this.data.pageCount);
      this.pageToGo = pageNumber;
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pagination-container"
  }, [_c('div', {
    staticClass: "mt-4  d-none d-md-flex justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_vm.pageSizeText ? _c('div', {
    staticClass: "p-2"
  }, [_c('label', [_vm._v(_vm._s(_vm.pageSizeText))])]) : _vm._e(), _vm._v(" "), _vm.showPageSizeOptions ? _c('div', {
    staticClass: "px-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pageSizeModel,
      expression: "pageSizeModel"
    }],
    staticClass: "form-control",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.pageSizeModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.pageSizeOptions, function (size, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": size
      }
    }, [_vm._v("\n            " + _vm._s(size) + "\n          ")]);
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-2"
  }, [_c('span', {
    staticClass: "pagination-info",
    class: {
      hidden: !_vm.showText
    }
  }, [_vm._v("\n          Mostrando " + _vm._s(_vm.startIndex) + " al " + _vm._s(_vm.endIndex) + " de\n          " + _vm._s(_vm.total) + " resultados\n        ")])])]), _vm._v(" "), _vm.showInputToGo ? _c('ul', {
    staticClass: "pagination mr-3 d-flex flex-wrap"
  }, [_c('span', {
    staticClass: "pt-2 mr-2 text"
  }, [_vm._v("Escriba # de página")]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.pageToGo,
      expression: "pageToGo"
    }],
    staticClass: "input-page form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.pageToGo
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.pageToGo = $event.target.value;
      }
    }
  })]), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: "bg-light-gray",
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.pageToGo);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-right"
  })])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "pagination mr-3 d-flex flex-wrap"
  }, [_vm.currentPage > _vm.pageButtonCount - _vm.pageButtonOffset ? _c('li', {
    staticClass: "mr-2 bg-light-gray"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.goToPage(1);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-double-left"
  })])]) : _vm._e(), _vm._v(" "), _vm.currentPage > 1 ? _c('li', {
    staticClass: "mr-2 bg-light-gray"
  }, [_c('a', {
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.currentPage - 1);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-left"
  })])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.pages, function (page, index) {
    return _c('li', {
      key: page,
      staticClass: "custom-border border-top border-bottom p-page",
      class: {
        first: index === 0,
        last: index === _vm.pages.length - 1,
        active: page === _vm.currentPage
      }
    }, [_c('a', {
      on: {
        "click": function ($event) {
          return _vm.goToPage(page);
        }
      }
    }, [_vm._v(_vm._s(page))])]);
  }), _vm._v(" "), _vm.currentPage < _vm.data.pageCount ? _c('li', {
    staticClass: "ml-2"
  }, [_c('a', {
    staticClass: "bg-light-gray",
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.currentPage + 1);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-right"
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "ml-2 bg-light-gray"
  }, [_vm.currentPage < _vm.data.pageCount - _vm.pageButtonOffset ? _c('a', {
    on: {
      "click": function ($event) {
        return _vm.goToLastPage();
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-double-right"
  })]) : _vm._e()])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-div mt-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('span', {
    staticClass: "pagination-info w-100 pagination-info-mobile",
    class: {
      hidden: !_vm.showText
    }
  }, [_vm._v("Mostrando " + _vm._s(_vm.startIndex) + " al " + _vm._s(_vm.endIndex) + " de\n          " + _vm._s(_vm.total) + " resultados")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "justify-content-between"
  }, [_c('ul', {
    staticClass: "pagination d-flex mobile"
  }, [_c('li', {
    staticClass: "mr-1 rounded bg-light-gray col"
  }, [_c('a', {
    attrs: {
      "id": _vm.id + "-GoToPrevious"
    },
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.currentPage - 1);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-left"
  })])]), _vm._v(" "), _vm._l(_vm.pagesMobile, function (page) {
    return _c('li', {
      key: page,
      staticClass: "custom-border rounded border-top border-bottom col",
      class: {
        activeMobile: page === _vm.currentPage
      }
    }, [_c('a', {
      class: {
        activeMobile: page === _vm.currentPage
      },
      attrs: {
        "id": _vm.id + "-GoToPage-" + page
      },
      on: {
        "click": function ($event) {
          return _vm.goToPage(page);
        }
      }
    }, [_vm._v(_vm._s(page))])]);
  }), _vm._v(" "), _c('li', {
    staticClass: "\n                rounded\n                custom-border-last\n                border-top border-bottom border-right\n                col\n              ",
    class: {
      activeMobile: _vm.lastPage === _vm.currentPage
    }
  }, [_c('a', {
    class: {
      activeMobile: _vm.lastPage === _vm.currentPage
    },
    attrs: {
      "id": _vm.id + "-GoToPage-" + _vm.lastPage
    },
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.lastPage);
      }
    }
  }, [_vm._v(_vm._s(_vm.lastPage))])]), _vm._v(" "), _c('li', {
    staticClass: "ml-1 rounded bg-light-gray col"
  }, [_c('a', {
    attrs: {
      "id": _vm.id + "-GoToNext"
    },
    on: {
      "click": function ($event) {
        return _vm.goToPage(_vm.currentPage + 1);
      }
    }
  }, [_c('em', {
    staticClass: "fa fa-chevron-right"
  })])])], 2)])])])])]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-248d49c0_0", {
    source: ".pagination-container .pagination-info[data-v-248d49c0]{text-align:left;font:Regular 16px/19px Lato;letter-spacing:0;color:#11291b;opacity:1}.pagination-container .input-page[data-v-248d49c0]{width:100px}.pagination-container .pagination[data-v-248d49c0]{cursor:pointer}.pagination-container .pagination li[data-v-248d49c0]{font:Bold 14px/17px Lato;background:#f2f2f2 0 0 no-repeat padding-box;border-radius:0;border:0}.pagination-container .pagination li.p-page[data-v-248d49c0]{background:#ffff}.pagination-container .pagination li[data-v-248d49c0]:not(.p-page){border-radius:4px;border:1px solid #dee2e6}.pagination-container .pagination li.active[data-v-248d49c0]{border-color:#2b9d71;background:#2b9d71;color:#fff;overflow:hidden}.pagination-container .pagination li.active a[data-v-248d49c0]{color:#fff}.pagination-container .pagination li.first[data-v-248d49c0]{border-top-left-radius:4px;border-bottom-left-radius:4px;border-left:1px solid #dee2e6;overflow:hidden}.pagination-container .pagination li.last[data-v-248d49c0]{border-top-right-radius:4px;border-bottom-right-radius:4px;border-right:1px solid #dee2e6;overflow:hidden}.pagination-container .pagination li[data-v-248d49c0]:last-child:empty{border-radius:0;border:0;background:0 0}.pagination-container .pagination li a[data-v-248d49c0]{min-width:33px;height:34px;position:relative;float:left;text-align:center;line-height:34px;letter-spacing:0;color:#11291b;text-decoration:none}.pagination-container .pagination .text[data-v-248d49c0]{text-align:left;font:\"Regular 16px/19px Lato\"!important;letter-spacing:0;color:#11291b;opacity:1}.pagination-container ul.mobile>li[data-v-248d49c0]:not(.activeMobile){background:#f2f2f2;border:1px solid #e2e2e2;border-radius:4px;color:#727273}.pagination-container .pagination>li a.activeMobile[data-v-248d49c0],.pagination-container li.activeMobile[data-v-248d49c0]{background:#fff 0 0 no-repeat padding-box;color:#2db782;border-radius:4px}.pagination-container ul.mobile>li>a[data-v-248d49c0]{margin:0 auto;width:100%;display:block}.pagination-container .pagination-info-mobile[data-v-248d49c0]{font-size:12px}.pagination-container .mobile-div[data-v-248d49c0]{display:none}@media only screen and (max-width:768px){.pagination-container .mobile-div[data-v-248d49c0]{display:block}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__ = "data-v-248d49c0";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

// Import vue component

const install = function installPagination(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('Pagination', __vue_component__);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__;
